var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-scrollbar"},[_c('div',{staticClass:"layout-view-bg-white flex layout-view-link"},[_c('a',{staticClass:"flex-margin",attrs:{"href":_vm.meta.isLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.meta.title)+"："+_vm._s(_vm.meta.isLink))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }